<template>
  <div>
    <v-dialog v-model="dialog" persistent eager scrollable max-width="600px">
      <v-form ref="AuthFormref" @submit.prevent>
        <v-card>
          <v-card-title class="d-flex">
            <span>Authentication Check</span>
            <v-spacer></v-spacer>
            <v-btn
              icon="mdi-close"
              variant="text"
              color="red"
              @click="closeD()"
            >
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 700px" class="">
            <v-container>
              <v-col cols="12">
                <v-text-field
                  v-model="pass"
                  :rules="[formRules.required, formRules.password]"
                  label="Password"
                  :color="$vuetify.theme.themes.light.inputColor"
                  :type="showPassword ? 'text' : 'password'"
                  :append-inner-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append-inner="showPassword = !showPassword"
                  variant="outlined"
                  density="compact"
                  class="mb-5"
                />
              </v-col>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-2">
            <v-spacer></v-spacer>

            <v-btn
              variant="outlined"
              density="compact"
              :color="$vuetify.theme.themes.light.submitBtnsGreen"
              class="white--text"
              @click="submit()"
            >
              submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
// import eventBus from "@/eventBus";
export default {
  props: {
    showDialog: Boolean,
  },
  data() {
    return {
      dialog: false,
      showPassword: false,
      pass: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    showDialog: {
      handler(data) {
        if (data) {
          this.dialog = true;
          this.$refs.AuthFormref.reset();
          this.$refs.AuthFormref.resetValidation();
          console.log("Love", data);
        }
      },
      deep: true,
    },
  },
  methods: {
    closeD() {
      this.dialog = false;
      this.$emit("validated", false);
    },
    validated() {
      this.dialog = false;
      this.$emit("validated", true);
    },
    submit() {
      if (this.$refs.AuthFormref.validate()) {
        let data = {
          password: this.pass,
        };
        this.axiosCall("/auth/authenticate", "POST", data).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.validated();
          } else if (res.data.status == 404) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        });
      }
    },
  },
};
</script>
